import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';
const parent = 'PUBLIC_'
export function proceduresLoad(filters){
  const url = `/anonymous/${API_VERSION_ONE}/procedures`;
  const method = 'GET'

  return {
    type: `${parent}PROCEDURES_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}